import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/auth-reducer";
import { authApi } from "./services/auth-api";
import { detailsApi } from "./services/details-api";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    [authApi.reducerPath]: authApi.reducer,
    [detailsApi.reducerPath]: detailsApi.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([authApi.middleware, detailsApi.middleware]),
});

export const { resetApiState } = detailsApi.util;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
